import axios from 'axios';
import { API_BASE } from './apiConfig';

const ADMIN = `${API_BASE}/api/admin`;

export const getSpaceConfig = (spaceId) =>
  axios.get(`${ADMIN}/spaces/${spaceId}/config`).then((r) => r.data);

export const updateSpaceConfig = (spaceId, config) =>
  axios.put(`${ADMIN}/spaces/${spaceId}/config`, config).then((r) => r.data);

export const getEntityConfig = (entityId) =>
  axios.get(`${ADMIN}/entities/${entityId}/config`).then((r) => r.data);

export const updateEntityConfig = (entityId, { currencyId, localeId, contractPercentage }) =>
  axios.put(`${ADMIN}/entities/${entityId}/config`, { currencyId, localeId, contractPercentage }).then((r) => r.data);

export const getSpaceCurrencyImpact = (spaceId, newCurrencyId) =>
  axios.get(`${ADMIN}/spaces/${spaceId}/currency-impact`, { params: { newCurrencyId } }).then((r) => r.data);

export const getEntityCurrencyImpact = (entityId, newCurrencyId) =>
  axios.get(`${ADMIN}/entities/${entityId}/currency-impact`, { params: { newCurrencyId } }).then((r) => r.data);

export const getLanguages = () =>
  axios.get(`${ADMIN}/languages`).then((r) => r.data);

export const getSpaceSupportedLanguages = (spaceId) =>
  axios.get(`${ADMIN}/spaces/${spaceId}/supported-languages`).then((r) => r.data);

export const updateSpaceSupportedLanguages = (spaceId, locales) =>
  axios.put(`${ADMIN}/spaces/${spaceId}/supported-languages`, { locales }).then((r) => r.data);
